import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import { Flex } from '@repo/pandacss/jsx';
import { Details } from '@repo/ui/Details';
import { MaskIcon } from '@repo/ui/primitives/MaskIcon';
import { Typography } from '@repo/ui/Typography';
import { renderStructuredContent } from '../../renderContext';
import type { StructuredContentDocument, StructuredContentDocumentWithRenderer } from '../../types';
export type AccordionItemProps = StructuredContentDocumentWithRenderer<{
  label: string;
  labelCollapsed: string;
  initialStateExpanded: boolean;
  children: StructuredContentDocument;
}>;
export const AccordionItem = t0 => {
  const $ = _c(23);
  const {
    props: t1
  } = t0;
  const {
    label,
    children
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      py: "[12px]"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== label) {
    t3 = <Typography variant="headline.small">{label}</Typography>;
    $[1] = label;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MaskIcon glyph="expand-more" css={{
      boxSize: "[20px]"
    }} style={{
      backgroundColor: "rgba(0,0,0,0.54)"
    }} />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3) {
    t5 = <Flex align="center" justify="space-between" css={t2}>{t3}{t4}</Flex>;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = `panel-content-${label}`;
  const t7 = `panel-header-${label}`;
  const t8 = `panel-header-${label}`;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = css.raw({
      px: "2",
      _hover: {
        bg: "blues.lightest",
        outlineWidth: "[2px]",
        outlineStyle: "solid",
        outlineColor: "blues.light",
        position: "relative",
        zIndex: "1"
      }
    });
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== t6 || $[8] !== t7 || $[9] !== t8) {
    t10 = {
      "data-testid": "accordion-summary",
      "aria-controls": t6,
      "aria-label": t7,
      id: t8,
      css: t9
    };
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      "data-testid": "accordion-details",
      css: css.raw({
        borderTopWidth: "[1px]",
        borderTopStyle: "solid",
        borderTopColor: "neutral.lighter",
        _lastOfType: {
          borderBottomWidth: "[1px]",
          borderBottomStyle: "solid",
          borderBottomColor: "neutral.lighter"
        }
      })
    };
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const t12 = `panel-content-${label}`;
  const t13 = `panel-header-${label}`;
  let t14;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = css({
      p: "3"
    });
    $[12] = t14;
  } else {
    t14 = $[12];
  }
  let t15;
  if ($[13] !== children) {
    t15 = renderStructuredContent(children);
    $[13] = children;
    $[14] = t15;
  } else {
    t15 = $[14];
  }
  let t16;
  if ($[15] !== t12 || $[16] !== t13 || $[17] !== t15) {
    t16 = <div id={t12} role="group" aria-labelledby={t13} className={t14}>{t15}</div>;
    $[15] = t12;
    $[16] = t13;
    $[17] = t15;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== t10 || $[20] !== t16 || $[21] !== t5) {
    t17 = <Details variant="simple" SummaryComponent={t5} summaryProps={t10} detailsProps={t11}>{t16}</Details>;
    $[19] = t10;
    $[20] = t16;
    $[21] = t5;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  return t17;
};